import { useEffect, useState } from "react";

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Select,
} from "@chakra-ui/react";
import { useBookingContext } from "../../context/BookingContext";
import {
  BookCard,
  BookCardTitle,
  BookCardSubtitle,
} from "../../components/Book/BookCard";
import { BookPlanCard } from "../../components/Book/BookPlanCard";
import { BaseInput } from "../../components/Base/BaseInput";
import { BaseText } from "../../components/Base/BaseText";

const BookConfirmPage = () => {
  const [plans, setPlans] = useState([0]);
  const { stepr } = useBookingContext();

  useEffect(() => {
    stepr.setStep(4);
  }, [stepr]);

  return (
    <Box>
      <BookCard mt={"10px"}>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <BookCardTitle small>Your Plans</BookCardTitle>
            <BookCardSubtitle small>
              You have selected following plans
            </BookCardSubtitle>
          </Box>
          <Box>
            <Button
              px="9"
              h="48px"
              bg="#E9EDF5"
              border="none"
              fontFamily="Inter"
              fontWeight="500"
              fontSize="16px"
              lineHeight="24px"
              color="#27489B"
              borderRadius="8px"
              onClick={() => setPlans([0, 1])}
            >
              Add Child
            </Button>
          </Box>
        </Box>

        <Box mt="6" display="flex" experimental_spaceX={"10px"}>
          {plans.map((plan, index) => (
            <BookPlanCard key={index} />
          ))}
        </Box>
      </BookCard>

      {/* Payment */}
      <BookCard mt={"10px"}>
        <BookCardTitle small>Payment Details</BookCardTitle>
        <BookCardSubtitle small>
          Enter your payments details to checkout
        </BookCardSubtitle>

        <Grid mt="3" gap={4} templateColumns="repeat(2, 1fr)">
          <GridItem colSpan={2}>
            <BaseInput label="Name of Cardholder" value="Whitney Blessing" />
          </GridItem>
          <GridItem colSpan={2}>
            <BaseInput
              label="Card Number"
              placeholder="••••  ••••  ••••  ••••"
            />
          </GridItem>
          <GridItem>
            <BaseInput label="Expiration Date" value="12/25" />
          </GridItem>
          <GridItem>
            <BaseInput label="Security Code" placeholder="•••" />
          </GridItem>
        </Grid>
      </BookCard>

      {/* Billing */}
      <BookCard mt={"10px"} mb={"60px"}>
        <BookCardTitle small>Billing Details</BookCardTitle>
        <BookCardSubtitle small>
          Please provide billing details
        </BookCardSubtitle>

        <Box mt="3">
          <BaseInput
            textarea
            rows={1}
            name="address-line-1"
            label="Address 1"
            placeholder="Address line 1"
          />
          <BaseInput
            mt={4}
            textarea
            rows={1}
            name="address-line-2"
            label="Address 2"
            placeholder="Address line 2"
          />
          <BaseText
            mt="2"
            display="flex"
            alignItems="center"
            experimental_spaceX={2}
            color="#3B82F6"
            font={["Inter", 400, "sm", "20px"]}
          >
            <i className="ri-information-fill"></i>
            <span>optional</span>
          </BaseText>

          <Grid gap={4} mt={4} templateColumns="repeat(2, 1fr)">
            <GridItem>
              <BaseInput
                name="city"
                label="City"
                value="Vidor"
                placeholder="Enter City"
              />
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel
                  fontFamily="Inter"
                  fontWeight={500}
                  fontSize="sm"
                  lineHeight="20px"
                  color={"#6B7280"}
                >
                  Province / State
                </FormLabel>
                <Select
                  placeholder="Select City"
                  fontFamily={"Inter"}
                  color={"#374151"}
                  fontWeight={"500"}
                  fontSize={"sm"}
                >
                  <option value="option1">Texas</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel
                  fontFamily="Inter"
                  fontWeight={500}
                  fontSize="sm"
                  lineHeight="20px"
                  color={"#6B7280"}
                >
                  Country
                </FormLabel>
                <Select
                  placeholder="Select Country"
                  fontFamily={"Inter"}
                  color={"#374151"}
                  fontWeight={"500"}
                  fontSize={"sm"}
                >
                  <option value="option1">USA</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem>
              <BaseInput
                value="77662"
                name="zip-code"
                label="Postal / ZIP Code"
                placeholder="Enter zip code"
              />
            </GridItem>
          </Grid>
        </Box>

        <Box mt="3" p="4" bg="#FAFAFA">
          <BaseText color="#202020" font={["Cairo", 700, "18px", "35px"]}>
            COPPA Direct Notice to Parents
          </BaseText>
          <BaseText mt="1" color="#374151" font={["Inter", 400, "sm", "20px"]}>
            Before we can provide your child with access to the Makerkids
            Learner Portal or to other features and activities on our website,
            we need your consent. Under the Children's Online Privacy Protection
            Act ("COPPA"), parental consent is required for the collection, use,
            or disclosure of personal information from children under the age of
            13. Makerkids will not collect, use, or disclose any personal
            information from your child unless you provide your{" "}
            <BaseText
              display="inline"
              color="#0EA5E9"
              font={["Inter", 400, "sm", "20px"]}
            >
              Read More
            </BaseText>
            .
          </BaseText>
        </Box>
        <BaseText mt="3" color="#6B7280" font={["Inter", 400, "sm", "20px"]}>
          By continuing, you have read the COPPA Direct Notice
        </BaseText>
      </BookCard>
    </Box>
  );
};

export { BookConfirmPage };
